/**
 * Format a numeric value to at most 2 decimal places.
 * Trailing zeros are stripped (e.g. 3.10 → 3.1, 4.00 → 4).
 */
export const formatDecimal = (v: number, decimals = 2): number =>
  parseFloat(v.toFixed(decimals));
